<template lang="pug">
    .component-backoffice-wallet
        | {{item.balance}}


</template>

<script type="text/babel">

    export default {
        name: "BackofficeWallet",
        props: {
            item: Object,
            type: {
                type: String,
                default: ''
            }
        },
        created() {
        },
        components: {

        },
        methods: {

        },
    }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Wallet.vue?190303c6